import { ReaderLayoutTableOfContentsSchema, ReaderLayoutProgressSliderSchema, ReaderLayoutButtonPropsSchema, ReaderLayoutReadAloudButtonPropsSchema, ReaderLayoutImagePropsSchema, ReaderLayoutLabelPropsSchema, ReaderLayoutInputPropsSchema, ReaderLayoutToastPropsSchema, ReaderLayoutSettingsSchema, ReaderLayoutBookmarksSchema, ReaderLayoutHighlightsSchema } from "./props";

export const LeafBlockDefs = {
    ReaderLayoutTableOfContents: {
        type: "ReaderLayoutTableOfContents",
        label: "Table of Contents",
        allowedRegions: [
            "leftDrawer", 
            "rightDrawer",
            "bottomDrawer",
            "modal",
        ],
        maxPerLayout: 1,
        propsSchema: ReaderLayoutTableOfContentsSchema,
        componentName: "ReaderLayoutTableOfContents",
    },
    ReaderLayoutSettings: {
        type: "ReaderLayoutSettings",
        label: "Settings",
        allowedRegions: [
            "leftDrawer", 
            "rightDrawer",
            "modal",
        ],
        maxPerLayout: 1,
        propsSchema: ReaderLayoutSettingsSchema,
        componentName: "ReaderLayoutSettings",
    },
    ReaderLayoutBookmarks: {
        type: "ReaderLayoutBookmarks",
        label: "Bookmark List",
        allowedRegions: [
            "leftDrawer", 
            "rightDrawer",
            "bottomDrawer",
            "modal",
        ],
        maxPerLayout: 1,
        propsSchema: ReaderLayoutBookmarksSchema,
        componentName: "ReaderLayoutBookmarks",
    },
    ReaderLayoutHighlights: {
        type: "ReaderLayoutHighlights",
        label: "Highlights List",
        allowedRegions: [
            "leftDrawer", 
            "rightDrawer",
            "bottomDrawer",
            "modal",
        ],
        maxPerLayout: 1,
        propsSchema: ReaderLayoutHighlightsSchema,
        componentName: "ReaderLayoutHighlights",
    },
    ReaderLayoutProgressSlider: {
        type: "ReaderLayoutProgressSlider",
        label: "Progress Slider",
        allowedRegions: [
            "topBar", 
            "bottomBar",
            "bottomDrawer",
            "leftBar",
            "rightBar",
        ],
        maxPerLayout: 1,
        propsSchema: ReaderLayoutProgressSliderSchema,
        componentName: "ReaderLayoutProgressSlider",
    },
    ReaderLayoutButton: {
        type: "ReaderLayoutButton",
        label: "Button",
        allowedRegions: [
            "topBar",
            "leftBar",
            "leftDrawer", 
            "rightBar",
            "rightDrawer", 
            "bottomBar", 
            "bottomDrawer", 
            "modal",
            "main",
        ],
        maxPerLayout: 0,
        propsSchema: ReaderLayoutButtonPropsSchema,
        componentName: "ReaderLayoutButton",
    },
    ReaderLayoutReadAloudButton: {
        type: "ReaderLayoutReadAloudButton",
        label: "Read Aloud Toggle",
        allowedRegions: [
            "topBar",
            "leftBar",
            "leftDrawer", 
            "rightBar",
            "rightDrawer", 
            "bottomBar", 
            "bottomDrawer", 
            "modal",
            "main",
        ],
        maxPerLayout: 0,
        requiresFeature: ["readaloud"],
        propsSchema: ReaderLayoutReadAloudButtonPropsSchema,
        componentName: "ReaderLayoutReadAloudButton",
    },
    ReaderLayoutImage: {
        type: "ReaderLayoutImage",
        label: "Image",
        allowedRegions: [
            "topBar",
            "leftBar",
            "leftDrawer", 
            "rightBar",
            "rightDrawer", 
            "bottomBar", 
            "bottomDrawer", 
            "modal"
        ],
        maxPerLayout: 0,
        propsSchema: ReaderLayoutImagePropsSchema,
        componentName: "ReaderLayoutImage",
    },
    ReaderLayoutLabel: {
        type: "ReaderLayoutLabel",
        label: "Text Label",
        allowedRegions: [
            "topBar",
            "leftBar",
            "leftDrawer", 
            "rightBar",
            "rightDrawer", 
            "bottomBar", 
            "bottomDrawer", 
            "modal"
        ],
        maxPerLayout: 0,
        propsSchema: ReaderLayoutLabelPropsSchema,
        componentName: "ReaderLayoutLabel",
    },
    ReaderLayoutInput: {
        type: "ReaderLayoutInput",
        label: "Input",
        allowedRegions: [
            "topBar",
            "leftDrawer", 
            "rightDrawer", 
            "bottomBar", 
            "bottomDrawer", 
            "modal"
        ],
        maxPerLayout: 0,
        propsSchema: ReaderLayoutInputPropsSchema,
        componentName: "ReaderLayoutInput",
    },
    ReaderLayoutToast: {
        type: "ReaderLayoutToast",
        label: "Toast",
        allowedRegions: [
            "main"
        ],
        maxPerLayout: 1,
        propsSchema: ReaderLayoutToastPropsSchema,
        componentName: "ReaderLayoutToast",
    }
} as const;
